import { render } from "./ProductEditor.vue?vue&type=template&id=6cdcfeb0&scoped=true"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"

import "./ProductEditor.vue?vue&type=style&index=0&id=6cdcfeb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdcfeb0"]])

export default __exports__